import { useEffect, useState } from 'react';
import { toPng } from 'html-to-image';
import download from 'downloadjs';

import { Row, Col, GRID } from '../components/custom';
import socket from '../socket';
import { generatePlotFromData, allAnalysisHidden } from './util';

export default function Tool()
{
    const [uploadState, setUploadState] = useState('hide');
    const [showVariables, setShowVariables] = useState('hide');
    const [categoricalVariables, setCategoricalVariables] = useState([]);
    const [numbericalVariables, setNumbericalVariables] = useState([]);
    const [opentextVariables, setOpentextVariables] = useState([]);
    const [availableAnalysis, setAvailableAnalysis] = useState({});
    const [showAnalysis, setShowAnalysis] = useState('hide');
    const [plotType, setPlotType] = useState('');
    const [plot, setPlot] = useState();
    const [insightsAndRecommendations, setInsightsAndRecommendations] = useState('');
    const [analysisDownloadState, setAnalysisDownloadState] = useState('Click to save Analysis as an image');

    const [placeHolder, setPlaceHolder] = useState(null);


    async function fileSelect(E)
    {
        const { target } = E;

        if (target.files.length === 0) return;

        setAvailableAnalysis(allAnalysisHidden());
        setUploadState('show');
        setShowVariables('hide');
        setShowAnalysis('hide');

        const form = new FormData();

        form.append('file', target.files[0]);

        const response = await fetch('/upload', {method: 'POST', body: form});

        const { filepath } = await response.json();

        document.querySelector('#tool input[type="file"]').dataset.filepath = filepath;

        socket.emit('f-getVar', {filepath});
    }

    function getSelectedVariables()
    {
        const selectedVariables = { categorical: [], numeric: [], opentext: [], isEmpty: false, type: null };

        document.querySelectorAll('#tool .variableContainer .categorical input:checked').forEach(x => selectedVariables.categorical.push(x.name));
        document.querySelectorAll('#tool .variableContainer .numeric input:checked').forEach(x => selectedVariables.numeric.push(x.name));
        document.querySelectorAll('#tool .variableContainer .opentext input:checked').forEach(x => selectedVariables.opentext.push(x.name));

        if ((selectedVariables.categorical.length === 0) && (selectedVariables.numeric.length === 0) && (selectedVariables.opentext.length === 0)) selectedVariables.isEmpty = true;

        else
        {
            if ((selectedVariables.categorical.length > 0) && (selectedVariables.numeric.length === 0) && (selectedVariables.opentext.length === 0)) selectedVariables.type = 'cat';
            if ((selectedVariables.categorical.length === 0) && (selectedVariables.numeric.length > 0) && (selectedVariables.opentext.length === 0)) selectedVariables.type = 'num';
            if ((selectedVariables.categorical.length === 0) && (selectedVariables.numeric.length === 0) && (selectedVariables.opentext.length > 0)) selectedVariables.type = 'opentext';
            if ((selectedVariables.categorical.length > 0) && (selectedVariables.numeric.length > 0) && (selectedVariables.opentext.length === 0)) selectedVariables.type = 'numANDcat';
            if ((selectedVariables.categorical.length > 0) && (selectedVariables.numeric.length === 0) && (selectedVariables.opentext.length > 0)) selectedVariables.type = 'opentextANDcat';
        }

        return selectedVariables;
    }

    function variableClick(E)
    {
        const dummy = allAnalysisHidden();

        const selectedVariables = getSelectedVariables();

        const { target } = E;

        // if (selectedVariables.categorical.includes(target.name)) document.querySelectorAll(`#tool .variableContainer .categorical input:not([name="${target.name}"])`).forEach(x => x.checked = false);
        if (selectedVariables.opentext.includes(target.name)) document.querySelectorAll(`#tool .variableContainer .opentext input:not([name="${target.name}"])`).forEach(x => x.checked = false);

        if (selectedVariables.type !== null)
        {
            const num = ['mean', 'top2', 'correlation', 'pairedTtest', 'multiple', 'logistic'];
            const cat = ['frequency', 'chi'];
            const numANDcat = [...num.slice(0, -3), 'Ttest', 'anova'];
            const opentext = ['wordCloud', 'sentiment', 'emotion', 'topicModelling', 'Ngrams'];
            const opentextANDcat = [...opentext.slice(0, -2)];

            const segregated = {num, cat, opentext, numANDcat, opentextANDcat};

            segregated[selectedVariables.type].forEach(x => dummy[x] = 'show');
        }

        setAvailableAnalysis(dummy);
    }

    function runAnalysis(E)
    {
        const { target } = E;

        const selectedVariables = getSelectedVariables();

        selectedVariables.type = target.dataset.analysisType;

        if (selectedVariables.type === 'multiple' || selectedVariables.type === 'logistic')
        {
            function end(E)
            {
                selectedVariables.numeric.splice(selectedVariables.numeric.indexOf(E.target.name), 1);
                selectedVariables.numeric.push(E.target.name);

                socket.emit('f-analysis', {selected: selectedVariables, filepath: document.querySelector('#tool input[type="file"]').dataset.filepath});
                
                setTimeout(() =>
                {
                    setPlaceHolder(null);
                    setPlotType(`${target.innerText} Plot`);
                    setInsightsAndRecommendations('');
                    setAnalysisDownloadState('Click to save Analysis as an image');
                    setShowAnalysis('show');
                }, 300);
            }

            const list = [];
            
            selectedVariables.numeric.forEach((x, i) =>
            {
                list.push(
                    <Row key={i} className='variable'>
                        <input type='checkbox' name={x} onChange={end}/>
                        <span className='descsmall'>{x}</span>
                    </Row>
                );
            });
    
            setPlaceHolder(
                <Col className='placeholder'>
                    <span className='desc'><strong>Select the Dependent Variable</strong></span>
                    <Col className='variables'>
                        {list}
                    </Col>
                </Col>
            );
        }

        else
        {
            setPlotType(`${target.innerText} Plot`);
            setInsightsAndRecommendations('');
            setAnalysisDownloadState('Click to save Analysis as an image');
            setShowAnalysis('show');

            socket.emit('f-analysis', {selected: selectedVariables, filepath: document.querySelector('#tool input[type="file"]').dataset.filepath});
        }
    }

    async function saveImage()
    {
        setAnalysisDownloadState('Downloading ...');

        const imageURL = await toPng(document.querySelector('#tool .analysis'));

        const img = new Image();
        img.src = imageURL;

        img.onload = () =>
        {
            const padding = 25;

            const canvas = document.createElement('canvas');
            canvas.height = img.height + (padding * 2 * 2);
            canvas.width = img.width + (padding * 2 * 2);

            const context = canvas.getContext('2d');
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.drawImage(img, padding * 2, padding);

            download(canvas.toDataURL('image/png'), 'analysis.png');

            setAnalysisDownloadState('Downloaded !');
        };
    }

    function getVar({vars: {categorical, numeric, opentext}})
    {
        let list;
    
        list = [...[]];
        
        categorical.forEach((x, i) =>
        {
            list.push(
                <Row key={i} className='variable'>
                    <input type='checkbox' name={x} onChange={variableClick}/>
                    <span className='descsmall'>{x}</span>
                </Row>
            );
        });
    
        setCategoricalVariables(list);
    
        list = [...[]];
        
        numeric.forEach((x, i) =>
        {
            list.push(
                <Row key={i} className='variable'>
                    <input type='checkbox' name={x} onChange={variableClick}/>
                    <span className='descsmall'>{x}</span>
                </Row>
            );
        });
    
        setNumbericalVariables(list);
    
        list = [...[]];
        
        opentext.forEach((x, i) =>
        {
            list.push(
                <Row key={i} className='variable'>
                    <input type='checkbox' name={x} onChange={variableClick}/>
                    <span className='descsmall'>{x}</span>
                </Row>
            );
        });
    
        setOpentextVariables(list);
    
        setUploadState('hide');
        setShowVariables('show');
    }

    useEffect(() =>
    {
        setAvailableAnalysis(allAnalysisHidden());

        socket.on('b-getVar', getVar);

        socket.on('b-analysis', (payload) =>
        {
            const plotData = generatePlotFromData(payload);

            setPlot(plotData);

            socket.emit('f-summarizeData', payload);
        });

        socket.on('b-summarizeData', setInsightsAndRecommendations);
    }, []);

    return (
        <Col id='tool'>
            <Row className='upload'>
                <Col className='steps'>
                    <span className='title'>Upload the survey data</span>
                    <span className='desc'>Please upload a clean Excel file with the following requirements:</span>
                    <ul>
                        <li className='descsmall'>The <strong>first row must contain column headers</strong> and each <strong>row should represent one complete response.</strong></li>
                        <li className='descsmall'>Ensure there are <strong>no merged cells, hidden rows/columns, or formulas.</strong> Data should be <strong>clean and consistent.</strong></li>
                    </ul>
                </Col>
                <Col className='buttons'>
                    <input className='descsmall' type='file' accept='.xlsx' onChange={async (E) => await fileSelect(E)}/>
                    <div className={`loader ${uploadState}`}/>
                </Col>
            </Row>
            <Col className={`variableContainer ${showVariables}`}>
                <span className='title'>Select the desired variables</span>
                {
                    categoricalVariables.length > 0 ? (
                        <Col className='categorical'>
                            <span className='desc'>Categorical Variables</span>
                            <GRID>
                                {categoricalVariables}
                            </GRID>
                        </Col>
                    ) : null
                }
                {
                    numbericalVariables.length > 0 ? (
                        <Col className='numeric'>
                            <span className='desc'>Numeric Variables</span>
                            <GRID>
                                {numbericalVariables}
                            </GRID>
                        </Col>
                    ) : null
                }
                {
                    opentextVariables.length > 0 ? (
                        <Col className='opentext'>
                            <span className='desc'>Open-Text Variables</span>
                            <GRID>
                                {opentextVariables}
                            </GRID>
                        </Col>
                    ) : null
                }
                <GRID className='buttons'>
                    <button className={`descsmall ${availableAnalysis.mean}`} data-analysis-type='mean' onClick={runAnalysis}>Mean Analysis</button>
                    <button className={`descsmall ${availableAnalysis.top2}`} data-analysis-type='top2' onClick={runAnalysis}>Top 2 % Analysis</button>
                    <button className={`descsmall ${availableAnalysis.correlation}`} data-analysis-type='correlation' onClick={runAnalysis}>Correlation</button>
                    <button className={`descsmall ${availableAnalysis.multiple}`} data-analysis-type='multiple' onClick={runAnalysis}>Multiple Regression</button>
                    <button className={`descsmall ${availableAnalysis.logistic}`} data-analysis-type='logistic' onClick={runAnalysis}>Logistic Regression</button>
                    <button className={`descsmall ${availableAnalysis.frequency}`} data-analysis-type='frequency' onClick={runAnalysis}>Frequency</button>
                    <button className={`descsmall ${availableAnalysis.wordCloud}`} data-analysis-type='wordCloud' onClick={runAnalysis}>Word Cloud</button>
                    <button className={`descsmall ${availableAnalysis.sentiment}`} data-analysis-type='sentiment' onClick={runAnalysis}>Sentiment Analysis</button>
                    <button className={`descsmall ${availableAnalysis.topicModelling}`} data-analysis-type='topicModelling' onClick={runAnalysis}>Topic Modelling</button>
                    <button className={`descsmall ${availableAnalysis.Ngrams}`} data-analysis-type='Ngrams' onClick={runAnalysis}>N-grams</button>
                    <button className={`descsmall ${availableAnalysis.emotion}`} data-analysis-type='emotion' onClick={runAnalysis}>Emotion Analysis</button>
                    <button className={`descsmall ${availableAnalysis.Ttest}`} data-analysis-type='Ttest' onClick={runAnalysis}>T-Test</button>
                    <button className={`descsmall ${availableAnalysis.pairedTtest}`} data-analysis-type='pairedTtest' onClick={runAnalysis}>Paired T-Test</button>
                    <button className={`descsmall ${availableAnalysis.anova}`} data-analysis-type='anova' onClick={runAnalysis}>ANOVA</button>
                    <button className={`descsmall ${availableAnalysis.chi}`} data-analysis-type='chi' onClick={runAnalysis}>Chi-Square Test</button>
                </GRID>
                { placeHolder }
            </Col>
            <Row className={`analysis ${showAnalysis}`}>
                <Col className='plot'>
                    <span className='title'>{plotType}</span>
                    {
                        insightsAndRecommendations.length < 1 ? (
                            <div className='loader'/>
                        ) : (
                            plot
                        )
                    }
                </Col>
                <Col className='insights'>
                    <span className='title'>Insights & Recommendations</span>
                    {
                        insightsAndRecommendations.length < 1 ? (
                            <div className='loader'/>
                        ) : (
                            <div className='descsmall' dangerouslySetInnerHTML={{__html: insightsAndRecommendations}}/>
                        )
                    }
                </Col>
            </Row>
            <Col className={`saveImage ${insightsAndRecommendations.length > 1 ? 'show' : 'hide'}`}>
                <button className='descsmall' onClick={async () => await saveImage()}>{analysisDownloadState}</button>
            </Col>
        </Col>
    )
}